// 91黑料 单页首页静态内容源（仅展示用，无接口）
export const heroStats = [
  { num: "1,286", label: "人物档案" },
  { num: "2,451", label: "事件条目" },
  { num: "318", label: "专题研究" },
  { num: "96", label: "时间线整理" },
];

export const hotTopics = [
  { rank: "01", label: "年度热瓜回顾", hot: 98, tag: "热" },
  { rank: "02", label: "人设争议与回应梳理", hot: 96, tag: "热" },
  { rank: "03", label: "合约与品牌解约风波", hot: 94, tag: "新" },
  { rank: "04", label: "直播带货信任危机", hot: 91, tag: "热" },
  { rank: "05", label: "旧物料考古与考古文", hot: 88, tag: "新" },
  { rank: "06", label: "声明文案逐字解析", hot: 85, tag: "" },
  { rank: "07", label: "舆论反转与道歉范本", hot: 82, tag: "" },
  { rank: "08", label: "综艺名场面出圈记录", hot: 79, tag: "冷" },
  { rank: "09", label: "税务与经营疑云盘点", hot: 76, tag: "" },
  { rank: "10", label: "恋情曝光时间线", hot: 73, tag: "新" },
];

export const tickerNews = [
  "人物档案库已扩容 214 条，含年度新增目录",
  "时间线专题《一场解约的 30 天》已归档",
  "冷门旧闻版块上线「老片考古」专区",
  "合集大全新增 2025 明星物料盘点清单",
  "热门争议条目已同步声明与回应版本",
];

export const catalog = [
  { icon: "ri-user-3-line", key: "人物", name: "人物档案", count: "1,286 篇", desc: "按人物归拢争议与回应、口碑变化与作品节点，看一个人物的完整脉络。" },
  { icon: "ri-map-pin-time-line", key: "事件", name: "事件复盘", count: "2,451 篇", desc: "把一条瓜拆成起因、发酵、反转、结局，还原事件从发生到收场的全过程。" },
  { icon: "ri-history-line", key: "时间线", name: "时间线整理", count: "96 条", desc: "以时间轴串联多个节点，快速看清一件事被反复提及的关键转折。" },
  { icon: "ri-stack-line", key: "专题", name: "专题研究", count: "318 个", desc: "围绕行业、现象与人群做纵深整理，跨对象对比，一次看懂一个话题。" },
];

export const collections = [
  {
    title: "2025 热门人物合集",
    desc: "按热度与话题度整理的当年度人物总览，含翻红、回归与争议路径。",
    tags: ["人物", "合集", "年度"],
    image: "https://readdy.ai/api/search-image?query=editorial%20magazine%20collage%20of%20vintage%20newspaper%20clippings%20and%20film%20portrait%20photos%20in%20warm%20cream%20and%20deep%20red%20tones%2C%20soft%20film%20grain%2C%20layered%20paper%20textures%2C%20moody%20studio%20lighting%2C%20cinematic%20visual%20archive%20aesthetic%2C%20high%20detail%20composition&width=800&height=600&seq=col-2025-x1&orientation=landscape",
  },
  {
    title: "声明与道歉原文库",
    desc: "汇集多份公开声明与道歉文案，逐段拆解措辞、语气与背后的态度变化。",
    tags: ["事件", "原文", "解析"],
    image: "https://readdy.ai/api/search-image?query=stack%20of%20aged%20official%20documents%20and%20typed%20letters%20on%20a%20warm%20paper%20desk%2C%20dark%20red%20ink%20stamp%20marks%2C%20soft%20window%20light%2C%20documentary%20photography%2C%20editorial%20archive%20mood%2C%20warm%20neutral%20background%2C%20high%20detail&width=800&height=600&seq=col-statement-x1&orientation=landscape",
  },
  {
    title: "品牌解约名录",
    desc: "梳理品牌与人物解约的时间节点、双方措辞与商业侧后续，看风向如何变化。",
    tags: ["事件", "商业", "盘点"],
    image: "https://readdy.ai/api/search-image?query=editorial%20flat%20lay%20of%20contracts%2C%20seals%20and%20corporate%20stationery%20with%20red%20accent%20details%2C%20warm%20cream%20background%2C%20soft%20shadows%2C%20minimal%20business%20journal%20photography%2C%20warm%20moody%20tone%2C%20high%20detail&width=800&height=600&seq=col-brand-x1&orientation=landscape",
  },
  {
    title: "综艺名场面收录",
    desc: "把一次次出圈的名场面、争议发言与后期应对收进同一份节目记忆清单。",
    tags: ["娱乐", "事件", "名场面"],
    image: "https://readdy.ai/api/search-image?query=backstage%20of%20a%20tv%20studio%20with%20spotlights%20and%20stage%20props%2C%20vintage%20television%20monitors%2C%20warm%20amber%20and%20deep%20red%20stage%20lighting%2C%20film%20grain%2C%20editorial%20entertainment%20photography%2C%20atmospheric%2C%20high%20detail&width=800&height=600&seq=col-show-x1&orientation=landscape",
  },
  {
    title: "电商带货争议档案",
    desc: "围绕直播带货的选品、话术与售后争议做行业向纵览，附平台规则更新。",
    tags: ["行业", "直播", "档案"],
    image: "https://readdy.ai/api/search-image?query=modern%20live%20streaming%20studio%20desk%20with%20ring%20light%20and%20products%2C%20laptop%20showing%20charts%2C%20warm%20cream%20tones%20with%20red%20accent%20lighting%2C%20editorial%20business%20photography%2C%20soft%20grain%2C%20documentary%20style%2C%20high%20detail&width=800&height=600&seq=col-live-x1&orientation=landscape",
  },
  {
    title: "翻红与回归路径",
    desc: "对比多位人物从沉寂到重新获得关注的节点、作品与舆论反应，找共同线索。",
    tags: ["专题", "人物", "趋势"],
    image: "https://readdy.ai/api/search-image?query=dramatic%20single%20spotlight%20on%20an%20empty%20theater%20stage%20with%20curtains%2C%20warm%20golden%20and%20deep%20red%20lighting%2C%20dust%20particles%20in%20light%2C%20cinematic%20editorial%20photography%2C%20atmospheric%2C%20high%20detail&width=800&height=600&seq=col-comeback-x1&orientation=landscape",
  },
];

export const personArchives = [
  {
    tag: "回归",
    title: "沉寂三年后重返荧幕：人气与口碑为何双双回温",
    meta: ["人物档案", "热度 96", "更新于 本周"],
    desc: "从消失、零星露面到综艺回归，逐步还原一位人物重获关注的完整路径与关键节点。",
    image: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20shadowed%20stage%20artist%20seen%20from%20behind%20facing%20warm%20backlight%2C%20crimson%20and%20amber%20tones%2C%20film%20grain%2C%20magazine%20cover%20aesthetic%2C%20dramatic%20chiaroscuro%2C%20high%20detail&width=720&height=900&seq=person-return-x1&orientation=portrait",
  },
  {
    tag: "争议",
    title: "一次公开表态引发的连锁反应：声明如何被逐句放大",
    meta: ["事件复盘", "热度 91", "声明解析"],
    desc: "同一段话在不同平台的二次传播路径整理，含网友解读、媒体标题与官方后续回应。",
    image: "https://readdy.ai/api/search-image?query=close%20up%20of%20hands%20holding%20a%20typed%20statement%20with%20red%20correction%20marks%20over%20a%20warm%20newsroom%20desk%2C%20crimson%20and%20cream%20tones%2C%20documentary%20editorial%20photography%2C%20soft%20grain%2C%20high%20detail&width=720&height=900&seq=person-statement-x1&orientation=portrait",
  },
  {
    tag: "反转",
    title: "从全网质疑到口碑回转：被舆论反复折叠的一年",
    meta: ["时间线整理", "热度 88", "节点 12"],
    desc: "以时间为轴标出数次转折，标注每一次发声与沉默分别把风向推向何处。",
    image: "https://readdy.ai/api/search-image?query=abstract%20editorial%20image%20of%20a%20spiral%20of%20newspaper%20headlines%20and%20facial%20silhouette%20in%20warm%20red%20and%20cream%20tone%2C%20layered%20paper%20shadows%2C%20conceptual%20archive%20art%2C%20soft%20grain%2C%20high%20detail&width=720&height=900&seq=person-flip-x1&orientation=portrait",
  },
  {
    tag: "考古",
    title: "旧物料考古特辑：一句多年前的发言如何被重新翻出",
    meta: ["冷门旧闻", "热度 82", "考古文"],
    desc: "把零散旧采访、老综艺画面重新拼合，标出它为何在当下被重新提起与传播。",
    image: "https://readdy.ai/api/search-image?query=vintage%20film%20reels%20and%20old%20polaroid%20photos%20pinned%20on%20a%20warm%20desk%2C%20faded%20magazine%20pages%2C%20crimson%20and%20sepia%20tones%2C%20nostalgic%20editorial%20archive%20photography%2C%20soft%20grain%2C%20high%20detail&width=720&height=900&seq=person-old-x1&orientation=portrait",
  },
];

export const timelineEvents = [
  { date: "2025-03", time: "09:00", title: "争议物料开始集中传播", note: "多平台同步出现相关内容，讨论量快速抬升。" },
  { date: "2025-03", time: "15:30", title: "首次公开回应上线", note: "以声明形式给出态度，措辞成为后续讨论焦点。" },
  { date: "2025-04", time: "—", title: "品牌侧表态与调整", note: "相关合作方陆续给出反应，商业关联开始被重新审视。" },
  { date: "2025-05", time: "—", title: "舆论出现反转支线", note: "新的旧物料与细节流出，主流判断出现分化。" },
  { date: "2025-06", time: "20:00", title: "公开道歉与后续安排", note: "以直播形式回应，并给出后续停更与调整计划。" },
];

export const specials = [
  { key: "行业", title: "直播带货的信任周期：从高光到复盘", summary: "把多起行业事件放进同一标尺，比较平台规则、主播话术与售后口径的演进。", meta: "跨 12 个对象 · 6 个时间节点" },
  { key: "现象", title: "「考古」为什么反复出圈", summary: "老物料在平台算法与怀旧情绪下如何被重新发现，背后的传播逻辑拆解。", meta: "覆盖 2012—2025" },
  { key: "方法", title: "一份声明该怎么读", summary: "从语气、措辞、回避项到发布时间，教你看懂公开表态背后的真实态度。", meta: "方法论 · 附对比示例" },
];

export const oldNews = [
  { title: "十年前的综艺台词，今天为何被重新提起", cat: "考古", tag: "冷" },
  { title: "一次未被注意的小型翻车，如何被做成大型解读", cat: "现象", tag: "冷" },
  { title: "早期采访里的口头禅，成了现在最常被引用的梗", cat: "考据", tag: "旧" },
  { title: "被折叠的老论坛帖子：互联网记忆的另一面", cat: "往事", tag: "旧" },
];

export const faqs = [
  { q: "这里的「黑料」到底指什么？", a: "站内按人物、事件与时间线整理公开信息与舆论记录，主要是让零散内容有一份可快速检索的总览，而非替任何人下结论。" },
  { q: "内容会定期更新吗？", a: "合集与大全按周持续整理。热门条目会随声明与后续进展补充版本，时间线专题也会在关键节点后归档成册。" },
  { q: "信息从哪里来？可信吗？", a: "所有条目均以已公开的访谈、声明、节目与报道为基础做归纳，并标注「声明/报道/考古」等来源类型，方便交叉比对。" },
  { q: "如何按需快速查找？", a: "可以按人物、事件、时间线或专题四个维度进入，也可用顶部搜索直达关键词，冷门旧闻另设独立专区。" },
  { q: "本站内容可以转载吗？", a: "页面以浏览与整理为主，暂不开放转载。引用请保留原始出处，具体以各原始媒体口径为准。" },
];